module.exports = __webpack_public_path__ + "static/img/noticia1.5010cf26.jpg";